import { AI_RESPONSE_DEFAULT_MODES } from './AIResponseActionMatrix.constants';
import type {
  AIResponseActionConfig,
  AIResponseActionDTO,
  AIResponseActionKeys
} from './AIResponseActionMatrix.types';

export const AIResponseBuildConfig = (
  actions: AIResponseActionDTO[],
  stored: AIResponseActionConfig
): AIResponseActionConfig =>
  actions.reduce<AIResponseActionConfig>((acc, action) => {
    const key = action.key as AIResponseActionKeys;
    acc[key] = {
      ...AI_RESPONSE_DEFAULT_MODES[key],
      ...stored[key]
    };
    return acc;
  }, {} as AIResponseActionConfig);

export type HostNameValidationResult =
  | { ok: true; values: string[] }
  | { ok: false; error: string };

export const normalizeAndValidateHostNames = (
  ...hostNameLists: string[][]
): HostNameValidationResult => {
  const values = hostNameLists.flat();
  if (values.some((value) => [...value].length > 255)) {
    return { ok: false, error: 'Host values must be 255 characters or fewer.' };
  }
  if (values.length > 10000) {
    return {
      ok: false,
      error: 'A maximum of 10,000 excluded hosts is allowed.'
    };
  }
  return { ok: true, values };
};

export default AIResponseBuildConfig;
